import Vue from 'vue';
import _ from 'lodash';

Vue.filter('placeholderDash', function (value) {
  // "0 " - value after currency-filter in operator cart
  return _.isUndefined(value) || value === "0 " ? '-' : value;
});
